/**
 * Dhobara Wishlist/Cart — localStorage utility
 *
 * Cart item shape:
 * {
 *   listingId: string,
 *   slug: string,
 *   title: string,
 *   designer: string,
 *   priceAmount: number,   // cents
 *   currency: string,
 *   imageUrl: string,
 *   savedAt: number,       // Date.now()
 * }
 */

const CART_KEY = 'dhobara_cart';

export const getCart = () => {
  try {
    const raw = localStorage.getItem(CART_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

const saveCart = items => {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
  } catch {
    // localStorage unavailable (SSR or private mode)
  }
};

export const getCartCount = () => getCart().length;

export const isInCart = listingId => getCart().some(item => item.listingId === listingId);

export const addToCart = item => {
  const cart = getCart();
  if (cart.some(i => i.listingId === item.listingId)) return; // already saved
  saveCart([...cart, { ...item, savedAt: Date.now() }]);
};

export const removeFromCart = listingId => {
  saveCart(getCart().filter(item => item.listingId !== listingId));
};

export const toggleCart = item => {
  if (isInCart(item.listingId)) {
    removeFromCart(item.listingId);
    return false; // now removed
  } else {
    addToCart(item);
    return true; // now saved
  }
};
